/* L5 Footer A (13.10.2026, Hugo: „ab dem Footer Live-Chat und Cookie-Button ausblenden“).
   Setzt <html class="gw-footer-sichtbar">, solange der Footer (kurz davor) im Bild ist. Das Ausblenden selbst
   macht assets/gw-footer.css; offene Widgets (Chat [open], Cookiebot .CookiebotWidget-open) bleiben sichtbar.
   Ohne JS oder ohne IntersectionObserver passiert nichts. */
(function () {
  var f = document.querySelector('.gwf');
  if (!f || !('IntersectionObserver' in window)) return;
  var h = document.documentElement;
  new IntersectionObserver(function (e) {
    h.classList.toggle('gw-footer-sichtbar', e[e.length - 1].isIntersecting);
  }, { rootMargin: '0px 0px 120px 0px' }).observe(f);
})();
